// extracted by mini-css-extract-plugin
export default {"input_main":"EditProfileModal_input_main__vRDIx","main":"EditProfileModal_main__YKtTa"};